document.addEventListener("DOMContentLoaded", () => {
  let pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  let pageHasWishlist =
    document.querySelector(".wishlist__grid") || false;
  let timeout = pageHasRecomendations || pageHasWishlist ? 2000 : 0;

  setTimeout(function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");
      let sectionName = "v2-main-product";
      // let sectionName = "test-section";

      quickViewControls.forEach((control) => {
        let handle = control.getAttribute("data-product-handle");

        if (handle) {
          control.addEventListener("click", () => {
            window.axios
              .get(`/products/${handle}?sections=${sectionName}`, {})
              .then(function (response) {
                // Success
                let script_index = 2;
                let html = response.data[`${sectionName}`];
                let script_parts = html.split("<script>");
                script = script_parts[script_index].replace("</script>", "");
                script = script.replace("</div>", "");
                script = script.replace('document.addEventListener("DOMContentLoaded", function() {', "");
                let closingBraceLocation = script.lastIndexOf("})");
                script = script.substring(0, closingBraceLocation)
                
                if (quickViewModalInner && html) {
                  quickViewModalInner.innerHTML = html;
                  eval(script);
                  getProductReview(html)
                  // init sliders
                  let gallery_thumbs_swiper = new window.swiper(
                    ".inner .thumb-swiper",
                    {
                      spaceBetween: 15,
                      slidesPerView: 'auto',
                      freeMode: true,
                      watchSlidesProgress: true,
                      breakpoints: {
                        992: {
                          slidesPerView: 'auto',
                          direction: "vertical",
                          watchSlidesProgress: true
                        },
                      },
                    }
                  );

                  let gallery_swiper = new window.swiper(
                    ".inner .main-swiper",
                    {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {

                          let check_width = setInterval(() => {
                            setThumbHeight()
                          }, 200);

                          function setThumbHeight() {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (main_swiper_width > 0) {

                              clearInterval(check_width);

                              thumb_swiper.style.cssText = "position: relative;opacity:1";

                              if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                              }
                            }
                          }

                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          window.addEventListener('resize', () => {

                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (window.innerWidth > 991.98) {

                              thumb_swiper.style.height = main_swiper_width + 'px';

                            }

                          });

                        }
                      },
                    }
                  );

                  // add listeners to product form
                  let productForm = quickViewModalInner.querySelector(
                    '[action="/cart/add"]'
                  );

                  if (productForm) {
                    productForm.addEventListener("submit", function (e) {
                      e.preventDefault();

                      let quantity = productForm.querySelector(
                        "input.quantity-selector"
                      ).value;
                      let id = productForm.querySelector("#product-id").value;

                      if (quantity && id) {
                        window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                      }
                    });
                  }

                  // add listener for read more
                  let read_more = quickViewModalInner.querySelector(
                    ".product-description-container[read-more-qf]"
                  );

                  if (read_more) {
                    let read_more_control =
                      read_more.querySelector(".read-more");
                    let excerpt = read_more.querySelector("span.excerpt");
                    let full = read_more.querySelector("span.full");

                    read_more_control.addEventListener("click", () => {
                      if (read_more.classList.contains("active")) {
                        read_more.classList.remove("active");
                        read_more_control.innerHTML = "Read more";
                      } else {
                        read_more.classList.add("active");
                        read_more_control.innerHTML = "Read less";
                      }
                    });
                  }

                  let btn_title = ''
                  if(window.location.hostname.includes('fr.')){
                    btn_title = 'Voir les détails'
                  }else{
                    btn_title = 'View full details'
                  }
                  quickViewModalInner.querySelector('.product-submit-wrapper').innerHTML = `<a href='/products/${handle}'>${btn_title}</a>`

                  // Show quick view modal
                  document.querySelector('body').classList.add('locked')
                  quickViewModal.classList.add("active");
                }
              })
              .catch(function (error) {
                // handle error
                window.log("Error:", error);
              })
              .then(function () {
                // always executed
                window.log("Complete");
              });
          });
        }
      });
      const getProductReview = (html) =>{
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const reviewBlock = parsedHTML.querySelector('.yotpo.bottomLine')
        const app_key = reviewBlock.dataset.appkey;
        const product_id = reviewBlock.dataset.productId;
        const review_place = quickViewModalInner.querySelector('.yotpo.bottomLine')
        const url = `https://api.yotpo.com/products/${app_key}/${product_id}/bottomline`;
        let starts = ""
        
        window.axios.get(url, {}).then(function ({data}) {
          let total_reviews = 0;
          if(data.status.code === 200) {
            const avarage_reviews = data.response.bottomline.average_score
            total_reviews = data.response.bottomline.total_reviews
            
            for( let i = 1; i <= 5; i++){
              let icon_class = i <= avarage_reviews ? "yotpo-icon-star" : "yotpo-icon-empty-star"
              if(!Number.isInteger(avarage_reviews) && i > avarage_reviews){
                icon_class = "yotpo-icon-half-star"
              }
              starts += `<span class="yotpo-icon ${icon_class} rating-star pull-left"></span>`
            }
          }
          let starts_wrapper = `<span class="yotpo-stars">${starts}</span>`;
          let stars_widget = `<div class="yotpo-display-wrapper" style="visibility: hidden;">  
                                <div class="standalone-bottomline" data-source="default" tabindex="-1"> 
                                    <div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">  
                                    ${starts_wrapper} 
                                    <span  class="text-m" aria-label="${total_reviews} reviews" tabindex="-1">${total_reviews} Reviews</span>   
                                    <div class="yotpo-clr"></div> 
                                  </div> 
                                <div class="yotpo-clr"></div> 
                              </div>   
                            <div class="yotpo-clr"></div> 
                          </div>`
          review_place.innerHTML = stars_widget
        })
      }
      document.querySelector(".quick-view-container .overlay").addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector('body').classList.remove('locked')
      });

      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector('body').classList.remove('locked')
      });
    }
  }, timeout);
});
